// extracted by mini-css-extract-plugin
export default {"root":"IconCancel_root__U52ZB"};